import { classed } from "@trydig/ui";
import styles from "./IntroSection.module.css";

export const IntroSection = classed.header(styles.root);
export const IntroSectionTitle = classed.h2(styles.title);
export const IntroSectionDescription = classed.p(styles.preamble);
